import { normaliseState } from '@pulsepoint/shared';

const dateTime = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' });
const dateOnly = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
const relative = new Intl.RelativeTimeFormat('en-AU', { numeric: 'auto' });

export const formatDateTime = (iso: string | null | undefined) => (iso ? dateTime.format(new Date(iso)) : '');
export const formatDate = (iso: string | null | undefined) => (iso ? dateOnly.format(new Date(iso)) : '');

/** "3 minutes ago", "yesterday", "12 Oct 2026" (beyond a month). */
export function formatAgo(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '';
  const secs = Math.round((new Date(iso).getTime() - now) / 1000);
  const abs = Math.abs(secs);
  if (abs < 60) return 'just now';
  if (abs < 3600) return relative.format(Math.round(secs / 60), 'minute');
  if (abs < 86_400) return relative.format(Math.round(secs / 3600), 'hour');
  if (abs < 30 * 86_400) return relative.format(Math.round(secs / 86_400), 'day');
  return formatDate(iso);
}

/** "Good morning", "Good afternoon", "Good evening". */
export function greeting(d = new Date()): string {
  const h = d.getHours();
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening';
}

export const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? name;

/** "Level 2, 12 Swan St, Richmond VIC 3121", skipping whatever is missing. */
export function addressLine(a: { addressLevel?: string | null; addressStreet?: string | null; addressSuburb?: string | null; addressState?: string | null; addressPostcode?: string | null }): string {
  const place = [a.addressSuburb, normaliseState(a.addressState) ?? a.addressState, a.addressPostcode].filter(Boolean).join(' ');
  return [a.addressLevel, a.addressStreet, place].filter(Boolean).join(', ');
}

/** A dollar amount for an input: "0.30", keeping extra digits only if an old value has them. */
export function moneyInput(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  return Math.abs(n * 100 - Math.round(n * 100)) < 1e-9 ? n.toFixed(2) : String(n);
}
